

const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec))

const searchShippingDayElement = async () => {
  for (let i = 0; i < 40; i++) {
      const shippingDayElement = $('div.delivery-date')
      if (shippingDayElement.length) {
          return shippingDayElement
      }
      await sleep(200)
  }
  return null
}
    
$.ajax({
    type: 'GET',
    url: '/cart.js',
    cache: false,
    dataType: 'json'
})
.then(
    cart => {
        const isGiftEnabledItemInCart = cart.items.some(item =>
            item.properties &&
                'ギフト購入' in item.properties &&
                item.properties['ギフト購入'] === '有効',
        )
        if (isGiftEnabledItemInCart) {
          searchShippingDayElement().then(element => {
            if (element) {
                element.remove()
            }
          })
        }                                        
    },
    error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
    }
);